import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
  FormGroup,
  Label,
  Button,
  Input,
  Form,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import querystring from "query-string";
import { object } from "prop-types";

import moment from "moment-timezone";

import DateRangePicker from "react-dates/lib/components/DateRangePicker";

import TableContainerWithLocation from "../../Components/TableContainerWithLocation";
import LoadingOverlay from "../../Components/LoadingOverlay";
import GenerateQrModal from "@/views/Components/QrCode/GenerateQrModal";
import transactions from "@/api/transactions";
import accounts from "@/api/accounts";
import reports from "@/api/reports";

import {
  dollarViewFormatter,
  rielViewFormatter,
  dateFormatter,
  moneyTableViewFormatter,
} from "@/util/formatter";

import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "react-bootstrap-table/dist/react-bootstrap-table.min.css";
import { APP_CONST } from "@/store/dataStore";
import { handleError } from "@/util/errorHandler";
const txTypes = ["ALL", "SEND_PAY", "DEPOSIT", "RECEIVE"];
const headerStyle = {
  backgroundColor: "#D15050",
  color: "white",
};

class AccountDetail extends Component {
  static propTypes = {
    location: object.isRequired,
  };

  state = {
    user: {
      accountId: "",
      accountType: "",
      address: "",
      balanceKhr: 0,
      balanceUsd: 0,
      createdTime: null,
      email: "string",
      externalId: 0,
      fullName: "",
      id: 0,
      participantBankId: 0,
      phoneNumber: "",
      publicKey: "",
    },

    from: null,
    to: null,
    focusedInput: null,
    type: "ALL",

    isDetailsLoading: true,

    isGenerateQrModalOpen: false,
  };

  onToggleGenerateQrModal = () => {
    this.setState(({ isGenerateQrModalOpen }) => ({
      isGenerateQrModalOpen: !isGenerateQrModalOpen,
    }));
  };

  viewFormatter = (cell, row) => (
    <Link
      to={{
        pathname: `/view_transaction/${this.state.user.accountId}/${row.fiTransactionId}`,
        state: { data: row },
      }}>
      <div>
        <i
          className="fa fa-search"
          style={{ color: "#D15050" }}
          data-cy="view-tx"
        />
      </div>
    </Link>
  );

  /* Ref to a TableContainerWithLocation, so we can call its methods */
  table = React.createRef();

  handleInputChange(event) {
    this.setState({
      type: event.target.value,
    });
  }

  handleFilterClick = () => {
    const { history, location } = this.props;

    const newQueryParams = {};

    if (this.state.type) {
      newQueryParams.type = this.state.type;
    }

    newQueryParams.from =
      this.state.from && this.state.from.format(APP_CONST.DATE_FROM);
    newQueryParams.to =
      this.state.to && this.state.to.format(APP_CONST.DATE_TO);

    const oldSearchQuery = querystring.parse(location.search);
    const newSearchQuery = querystring.stringify({
      ...oldSearchQuery,
      ...newQueryParams,
    });

    history.push({
      ...location,
      search: newSearchQuery,
    });

    setImmediate(() => {
      this.table.loadAndStoreData();
    });
  };

  loadPagination = (page = 0, size = 10, filter = "", sort = "") => {
    const { type, from, to } = querystring.parse(this.props.location.search);

    return transactions.getAccountTransactions(
      this.props.match.params.id,
      page,
      size,
      filter,
      sort,
      type,
      from,
      to,
    );
  };

  loadAccountDetails = async id => {
    try {
      return await accounts.getAccountDetails(id).then(data =>
        this.setState({
          user: data,
        }),
      );
    } catch (error) {
      handleError(new Error(error.response));
    } finally {
      this.setState({ isDetailsLoading: false });
    }
  };

  componentDidMount() {
    const id = this.props.match.params.id;

    const { type, from, to } = querystring.parse(this.props.location.search);

    if (type || from || to) {
      this.setState({
        type,
        from: from ? moment(from, APP_CONST.DATE_FROM) : null,
        to: to ? moment(to, APP_CONST.DATE_TO) : null,
      });
    }

    this.loadAccountDetails(id);
  }

  goBack = () => {
    /*
     *  WARN: don't change it, because goBack() uses browser history
     *  and returns user just to previous filter in url,
     *  but not previous location in bread crumbs
     */
    const {
      location: { state },
    } = this.props;
    if (state && state.previousLocation) {
      this.props.history.push(state.previousLocation);
    } else {
      this.props.history.push("/total_account");
    }
  };

  render() {
    const { user } = this.state;

    return (
      <div className="animated fadeIn">
        <Row>
          <Col>
            <Card>
              <CardHeader>
                Account Details: {this.props.match.params.id}
              </CardHeader>
              <CardBody>
                <Row className="mb-4">
                  <Col>
                    <Button
                      color="primary"
                      type="button"
                      onClick={this.goBack}
                      data-cy="back-from-account-detail">
                      <i className="fa fa-arrow-left mr-2 " />
                      Back
                    </Button>
                  </Col>
                  <Col>
                    <Button
                      color="warning"
                      onClick={this.onToggleGenerateQrModal}>
                      <span>Generate QR code</span>
                    </Button>
                  </Col>
                </Row>

                <Row style={{ position: "relative" }}>
                  <LoadingOverlay loading={this.state.isDetailsLoading} />
                  <Col sm={12} md={6}>
                    <ListGroup>
                      {user.accountType === "MOBILE" && (
                        <ListGroupItem>
                          Fullname: <strong>{user.fullName}</strong>
                        </ListGroupItem>
                      )}
                      {user.accountType === "DESKTOP" && (
                        <ListGroupItem>
                          Organisation: <strong>{user.organizationName}</strong>
                        </ListGroupItem>
                      )}
                      <ListGroupItem>
                        Email: <strong>{user.email}</strong>
                      </ListGroupItem>
                      {user.accountType === "MOBILE" && (
                        <ListGroupItem>
                          Phone number: <strong>{user.phoneNumber}</strong>
                        </ListGroupItem>
                      )}
                      <ListGroupItem>
                        Registered date:{" "}
                        <strong>{dateFormatter(user.createdTime)}</strong>
                      </ListGroupItem>
                      <ListGroupItem>
                        Account type: <strong>{user.accountType}</strong>
                      </ListGroupItem>
                    </ListGroup>
                  </Col>
                  <Col sm={12} md={6}>
                    <h4>Available balance:</h4>
                    <ListGroup>
                      <ListGroupItem>
                        KHR:{" "}
                        <strong>
                          {rielViewFormatter(
                            user.assets && user.assets["khr#nbc"],
                          )}
                        </strong>
                      </ListGroupItem>
                      <ListGroupItem>
                        USD:{" "}
                        <strong>
                          {dollarViewFormatter(
                            user.assets && user.assets["usd#nbc"],
                          )}
                        </strong>
                      </ListGroupItem>
                    </ListGroup>
                  </Col>
                </Row>

                <hr />

                <Form
                  inline
                  style={{
                    marginBottom: "1.25rem",
                    justifyContent: "flex-end",
                  }}>
                  <FormGroup
                    className="mb-2 mr-sm-2 mb-sm-0"
                    style={{ paddingRight: "2rem" }}>
                    <DateRangePicker
                      startDate={this.state.from}
                      startDateId="date_from"
                      endDate={this.state.to}
                      endDateId="date_to"
                      onDatesChange={({ startDate, endDate }) =>
                        this.setState({ from: startDate, to: endDate })
                      }
                      focusedInput={this.state.focusedInput}
                      onFocusChange={focusedInput =>
                        this.setState({ focusedInput })
                      }
                      showClearDates
                      showDefaultInputIcon
                      isOutsideRange={date =>
                        moment(date).isAfter(
                          moment.tz("Asia/Phnom_Penh").endOf("day"),
                        )
                      }
                      small
                      minimumNights={0}
                    />
                  </FormGroup>
                  <FormGroup
                    className="mb-2 mr-sm-2 mb-sm-0"
                    style={{ paddingRight: "2rem", alignItems: "baseline" }}>
                    <Label htmlFor="type" style={{ marginRight: "1rem" }}>
                      <h6>Transaction Type:</h6>
                    </Label>
                    <Input
                      type="select"
                      name="type"
                      id="type"
                      value={this.state.type}
                      onChange={event => this.handleInputChange(event)}>
                      {txTypes.map(item => {
                        return (
                          <option value={item} key={item}>
                            {item}
                          </option>
                        );
                      })}
                    </Input>
                  </FormGroup>
                  <Button
                    color="primary"
                    type="button"
                    onClick={this.handleFilterClick}
                    data-cy="filter">
                    Filter
                  </Button>
                </Form>
                <Row>
                  <Col>
                    <TableContainerWithLocation
                      loadData={this.loadPagination}
                      requestReport={reports.requestAccountTransactions}
                      reportAdditionalParams={this.props.match.params}
                      wrappedComponentRef={innerComponent => {
                        // Forwarding ref to TableContainerWithLocation through 'withRouter' HOC
                        // This is the only way to forward ref with React Router 4
                        if (innerComponent) {
                          this.table = innerComponent;
                        }
                      }}>
                      <BootstrapTable
                        data={this.props.data}
                        options={this.props.options}
                        fetchInfo={this.props.fetchInfo}
                        headerStyle={headerStyle}
                        version="4"
                        search={this.props.search}
                        pagination
                        striped
                        hover
                        condensed
                        remote
                        exportCSV>
                        <TableHeaderColumn
                          dataFormat={this.viewFormatter}
                          dataField="view"
                          width="60"
                          dataAlign="center">
                          View
                        </TableHeaderColumn>
                        <TableHeaderColumn
                          dataSort
                          dataField="transactionHash"
                          width="200"
                          isKey>
                          Trx Hash
                        </TableHeaderColumn>
                        <TableHeaderColumn
                          dataSort
                          dataFormat={dateFormatter}
                          dataField="transactionCreatedTime"
                          width="160">
                          Entry Date
                        </TableHeaderColumn>
                        <TableHeaderColumn
                          dataSort
                          dataField="sourceAccountId"
                          width="150">
                          From Account
                        </TableHeaderColumn>
                        <TableHeaderColumn
                          dataSort
                          dataField="destinationAccountId"
                          width="150">
                          To Account
                        </TableHeaderColumn>
                        <TableHeaderColumn
                          dataSort
                          dataField="currencyName"
                          width="70"
                          dataAlign="center">
                          CCY
                        </TableHeaderColumn>
                        <TableHeaderColumn
                          dataSort
                          dataField="amount"
                          dataFormat={moneyTableViewFormatter}
                          width="100"
                          dataAlign="right">
                          Amount
                        </TableHeaderColumn>
                        <TableHeaderColumn
                          dataSort
                          dataField="transactionType"
                          width="150"
                          dataAlign="left">
                          Transaction Type
                        </TableHeaderColumn>
                      </BootstrapTable>
                    </TableContainerWithLocation>
                  </Col>
                </Row>
              </CardBody>
            </Card>

            <GenerateQrModal
              isOpen={this.state.isGenerateQrModalOpen}
              onModalClose={this.onToggleGenerateQrModal}
              userAccountId={this.state.user.accountId}
              organizationName={this.state.user.organizationName}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

export default AccountDetail;
